export default {
  candidates: [],
  candidate: undefined,
};
